import { Link, useStaticQuery, graphql } from 'gatsby';
import React, { useState, useRef, useEffect, Fragment } from 'react';
import { getYear } from 'date-fns';
import _ from 'lodash';
import IconXCircle from '../icon/icon-x-circle';
import IconArrow from '../icon/icon-arrow-right';
import Lockup from './lockup';
import Hamburger from './hamburger';
import ReactMarkdown from 'react-markdown/with-html';
import algoliasearch from 'algoliasearch/lite';
import {
  InstantSearch,
  Index,
  Configure,
  Hits,
  connectStateResults,
  connectSearchBox,
  connectCurrentRefinements,
  Highlight
} from 'react-instantsearch-dom';

const searchClient = () => {
  const algoliaClient = algoliasearch('TRM4BPTIMD', '643b9f6e035bfeeca0ee99f3502b65dd')
  return {
    search(requests) {
      const shouldSearch = requests.some(({ params: { query } }) => query.length >= 3)
      if (shouldSearch) {
        return algoliaClient.search(requests)
      }
      return Promise.resolve({
        results: [{ hits: [] }]
      })
    },
    searchForFacetValues: algoliaClient.searchForFacetValues
  }
}

const Header = ({scrolled, classes}) => {

  const [collapsed, setCollapsed] = useState(false);
  const toggle = () => {
    setCollapsed(!collapsed);
    setSearch(false);
    !collapsed ? document.body.classList.add('js-nav-active') :
      document.body.classList.remove('js-nav-active');
  };

  const [more, setMore] = useState(false);
  const toggleMore = () => {
    setMore(!more);
  };


  const [searchToggled, setSearch] = useState(false);
  const toggleSearch = () => {
    setSearch(!searchToggled);
    if (!searchToggled) {
      setTimeout(function () {
        document.getElementById('omni-search-input').focus();
      }, 750);
    }
  };

  const ClearRefinements = ({ items, refine }) => (
    <div className="close-omni" onClick={() => refine(items)} disabled={!items.length}>
      <IconXCircle collapsed={collapsed} handleToggle={toggle} />
    </div>
  );

  const CustomClearRefinements = connectCurrentRefinements(ClearRefinements);

  const SearchBox = connectSearchBox(({ refine, currentRefinement, children }) => {

    const [showResults, setShowResults] = useState('none')

    const inputRef = useRef({ value: null })
    const resultsRef = useRef({ value: null })

    const isShowResults = query => setShowResults(query.length > 0 ? 'block' : 'none')
    const handleFocus = e => isShowResults(e.target.value)

    useEffect(() => {
      isShowResults(inputRef.current.value)
    }, [inputRef.current.value])

    return (
      <Fragment>
        <form noValidate action="" role="search" className="omni-search" id="omni-search">
          <input
            ref={inputRef}
            onChange={e => refine(e.target.value)}
            value={currentRefinement}
            onFocus={handleFocus}
            className="form-control mr-sm-2"
            aria-label="Search"
            type="search"
            placeholder="Search"
            id="omni-search-input"
          />
          <div ref={resultsRef} style={{ display: showResults }}>
            {' '}
            {children}{' '}
          </div>
        </form>
      </Fragment>
    )
  })

  const CustomSearchBox = connectSearchBox(SearchBox);

  const Results = connectStateResults(({ searchState: state, searchResults: res, children }) =>
    res && res.nbHits > 0 && state.query.length >= 3 ? (
      children
    ) : (
        <div className="search__results_empty"></div>
      )
  )

  const PostPreview = ({ hit }) => {
    return (
      <div>
        <Link onClick={toggle} to={`/perspectives/` + hit.slug.current}>
          <Highlight hit={hit} attribute="title" tagName="mark" />
        </Link>
      </div>
    )
  }

  const PeoplePreview = ({ hit }) => {
    return (
      <div>
        <Link onClick={toggle} to={`/people/` + hit.slug.current}>
          <Highlight hit={hit} attribute="name" tagName="mark" />
        </Link>
      </div>
    )
  }

  const CompanyPreview = ({ hit }) => {
    return (
      <div>
        <Link onClick={toggle} to={`/case-study/` + hit.slug.current}>
          <Highlight hit={hit} attribute="title" tagName="mark" />
        </Link>
      </div>
    )
  }

  const CompanyNoCasePreview = ({ hit }) => {
    let catId = '';
    if (hit.categories.length > 0) {
      catId = hit.categories[0]._id + '/';
    }
    return (
      <div>
        <Link onClick={toggle} to={`/partnerships/` + catId + '#' + hit.slug.current}>
          <Highlight hit={hit} attribute="title" tagName="mark" />
        </Link>
      </div>
    )
  }

  const Search = () => (
    <Fragment>
      <InstantSearch searchClient={searchClient()} indexName="blog">
        <CustomClearRefinements clearsQuery />
        <CustomSearchBox />
        <div className="search-results" id="omni-search-results">
          <Index indexName="blog">
            <Results>
              <h4 className="mt-4">Blog Posts</h4>
              <Configure hitsPerPage={5} />
              <Hits hitComponent={PostPreview} />
            </Results>
          </Index>
          <Index indexName="people">
            <Results>
              <h4 className="mt-4">People</h4>
              <Configure hitsPerPage={5} />
              <Hits hitComponent={PeoplePreview} />
            </Results>
          </Index>
          <Index indexName="company">
            <Results>
              <h4 className="mt-4">Case Study</h4>
              <Configure hitsPerPage={5} />
              <Hits hitComponent={CompanyPreview} />
            </Results>
          </Index>
          <Index indexName="companyNoCase">
            <Results>
              <h4 className="mt-4">Company</h4>
              <Configure hitsPerPage={5} />
              <Hits hitComponent={CompanyNoCasePreview} />
            </Results>
          </Index>
        </div>
      </InstantSearch>
    </Fragment>
  );

  const [isScrolled, setScrolled] = useState(false);
  const [initScrolled, setInitScrolled] = useState(false);
  const [testHeader, setTestHeader] = useState(null);
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.search) {
      if (window.location.search.indexOf('test=transparent') > -1) {
        setTestHeader('transparent');
      }
      if (window.location.search.indexOf('test=darktransparent') > -1) {
        setTestHeader('transparent dark-assets');
      }
    }
    if (typeof window !== 'undefined' && window.location.pathname === '/' && 'pageApi' in window) {
      // console.log('Scrolled', scrolled);
      setScrolled(scrolled);
    } else if (!isScrolled && !initScrolled) {
      setScrolled(true);
    }
  }, [setInitScrolled, initScrolled, setScrolled, isScrolled])

  const data = useStaticQuery(graphql`
    query MenuQuery {
      allSanityMenus {
        edges {
          node {
            title
            moreMenu {
              title
              link
              external
            }
            mainMenu {
              title
              link
              external
            }
            secondaryMenu {
              title
              link
              external
            }
          }
        }
      }
      site: sanitySiteSettings(_id: {regex: "/(drafts.|)siteSettings/"}) {
        disclaimer
      }
    }
  `);

  const primaryMenu = _.get(data, 'allSanityMenus.edges[0].node.mainMenu', []);
  const secondaryMenu = _.get(data, 'allSanityMenus.edges[0].node.secondaryMenu', []);
  const moreMenu = _.get(data, 'allSanityMenus.edges[0].node.moreMenu', []);
  const disclaimer = _.get(data, 'site.disclaimer', '');
    // transparent dark-assets
  return (
    <Fragment>
      <header key={scrolled} id="header" className={`navbar-dark ${classes && classes.join(' ')} fixed-top ${isScrolled ? 'scrolled' : ''} ${scrolled ? 'scrolled' : ''}`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <Lockup />
              <Hamburger collapsed={collapsed} handleToggle={toggle} />
            </div>

            <div className={`navbar-collapse ${collapsed ? 'collapse show' : 'collapse'}`} id="main-nav">

              <div className={`omni-search-window ${searchToggled ? 'is-active' : ''}`}>
                <div className="omni-search-scroll">
                  <div className="omni-search-inner">
                    <Search />
                  </div>
                </div>
              </div>

              <div className="main-nav-scroll">
                <div className="main-nav-inner">

                  <div className="main-nav-center">
                    <a href="#" className="navbar-x" data-toggle="collapse" data-target="#main-nav" aria-controls="main-nav" aria-expanded="false" aria-label="Toggle navigation">
                      <IconXCircle collapsed={collapsed} handleToggle={toggle} />
                    </a>

                    <ul className="navbar-nav navbar-main">
                      {primaryMenu.map(menu => (
                        <li className="nav-item" key={menu.title}>
                          {menu.external ? (
                            <a href={menu.link} className="nav-link nav-link--primary" target="_blank" rel="noopener noreferrer">{menu.title}</a>
                          ) : (
                              <Link to={menu.link} className="nav-link nav-link--primary" onClick={toggle}>{menu.title}</Link>
                            )}
                        </li>
                      ))}
                    </ul>

                    <hr />

                    <ul className="navbar-nav navbar-sub">
                      {secondaryMenu.map(menu => (
                        <li className="nav-item" key={menu.title}>
                          {menu.external ? (
                            <a href={menu.link} className="nav-link nav-link--secondary" target="_blank" rel="noopener">{menu.title}</a>
                          ) : (
                              <Link to={menu.link} className="nav-link nav-link--secondary" onClick={toggle}>{menu.title}</Link>
                            )}
                        </li>
                      ))}
                    </ul>

                    <div className="navbar-nav navbar-more">
                      <a className={`nav-link nav-link--secondary navbar-more__button js--more-expand ${more ? 'active' : ''}`} href="#" onClick={toggleMore}>
                        More{' '}
                        <IconArrow />
                      </a>

                      <div id="js--more-expand" className={`js--more ${more ? '' : 'inactive'}`}>
                        {moreMenu.map(menu => (
                          menu.external ? (
                            <a href={menu.link} className="nav-link nav-link--tertiary" key={menu.title} target="_blank" rel="noopener noreferrer">{menu.title}</a>
                          ) : (
                              <a href={menu.link} className="nav-link nav-link--tertiary" key={menu.title} onClick={toggle}>{menu.title}</a>
                            )
                        ))}
                      </div>

                      <div className="omni-search">
                        <button className="toggle-omni-search" id="toggle-omni-search" onClick={toggleSearch}>Search</button>
                      </div>
                    </div>
                  </div>

                  <div className="legal-disclaimer">
                    {disclaimer && <ReactMarkdown source={disclaimer} />}
                    <p>
                      &copy; {getYear(new Date)} Kleiner Perkins
                    </p>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </header>
    </Fragment >
  );
};

export default Header;
